import { useFetchMyRfqQuotationsQuery } from '@generated/graphql';
import useDocuments from '@hooks/useDocuments';
import React from 'react';
import { QuotationListDrawer, QuotationListDropdown } from '../Common';

interface Props {
  matches: boolean;
  rfqId?: string;
  partnerId?: string;
}

const QuotationList = ({ matches, rfqId, partnerId }: Props) => {
  const {
    onUpdateDocumentsCurrentId,
    onUpdateDocumentsOptions
  } = useDocuments();

  const { data } = useFetchMyRfqQuotationsQuery({
    variables: {
      input: {
        rfqId: rfqId ?? '',
        quotationPartnerId: partnerId ?? ''
      }
    },
    skip: !rfqId || !partnerId,
    fetchPolicy: 'cache-first'
  });

  const quotations = data?.fetchMyRfqQuotations.data ?? [];

  const items = quotations.map((q) => ({
    id: q.id ?? '',
    createdAt: q.createdAt ?? '',
    quotationPrice: q.quotation ?? 0,
    dueDate: q.dueDate ?? '',
    isLatest: q.latest ?? false
  }));

  const onClick = (id: string) => {
    onUpdateDocumentsCurrentId({ selectedQuotationId: id });

    onUpdateDocumentsOptions({ listAnchorId: undefined });
  };

  return (
    <>
      {matches && (
        <QuotationListDrawer
          items={items}
          title="견적서 발행이력"
          onClick={onClick}
        />
      )}
      {!matches && (
        <QuotationListDropdown
          items={items}
          title="견적서 발행이력"
          onClick={onClick}
        />
      )}
    </>
  );
};

export default QuotationList;
